import i18n from 'i18next';
import { array, boolean, string } from 'yup';
import { emailRegExp, phoneRegExp } from 'globalutils/constants';
import { isInsuracePortalUser } from 'globalutils/fmUtils';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { checkServiceProvider } from './serviceProviderConfig';

const insuracePortalUserRole = isInsuracePortalUser();

const getDefaultSchema = ({ user }) => ({
  firstName: string()
    .test('len', i18n.t('common.atleast2Chars'), (val) => val && val.length > 1)
    .required(i18n.t('common.fieldRequiredMessage')),
  lastName: string()
    .test('len', i18n.t('common.atleast2Chars'), (val) => val && val.length > 1)
    .required(i18n.t('common.fieldRequiredMessage')),

  phone: string().matches(phoneRegExp, i18n.t('common.validNumFormat')).required(i18n.t('common.fieldRequiredMessage')),
  company:
    user?.userEditDto?.allRolesMap?.DRIVER && insuracePortalUserRole
      ? string().required('common.fieldRequiredMessage')
      : string(),
  email:
    user?.userEditDto?.allRolesMap?.DRIVER && checkServiceProvider('schema_email', window?.$environment?.SERVICE_PROVIDER, false)
      ? string().matches(emailRegExp, i18n.t('common.emailValidationMessage'))
      : string().matches(emailRegExp, i18n.t('common.emailValidationMessage')).required(i18n.t('common.fieldRequiredMessage')),
  hireDate: string().when('email', {
    is: () => checkServiceProvider('schema_hireDate', window?.$environment?.SERVICE_PROVIDER, false),
    then: string().required('common.fieldRequiredMessage'),
    otherwise: string(),
  }),
  roles: boolean()
    .nullable()
    .when(
      [
        'fleetManagerRole',
        'adminRole',
        'driverRole',
        'mechanicRole',
        'serviceManagerRole',
        'underWriterRole',
        'lossControlRole',
        'claimAdjusterRole',
      ],
      (fM, aR, dR, mR, sM, uW, lC, cA, schema) => {
        return schema.test({
          test: () => {
            return !(!fM && !aR && !dR && !mR && !sM && !uW && !lC && !cA);
          },
          message: i18n.t('common.fieldRequiredMessage'),
        });
      }
    ),
  licenseNumber: string().when('driverRole', {
    is: (val) => {
      return val;
    },
    then: string()
      .required(i18n.t('common.fieldRequiredMessage'))
      .matches(/^[a-zA-Z0-9]*$/, i18n.t('common.validLicenseNumber')),
    otherwise: string().nullable(),
  }),
  licenseState: string().when('driverRole', {
    is: (val) => {
      return val;
    },
    then: string().required(i18n.t('common.fieldRequiredMessage')),
    otherwise: string().nullable(),
  }),
  empId: string().when('driverRole', {
    is: (val) => {
      return val;
    },
    then: string()
      .trim()
      .strict(true)
      .max(45, 'Id must be at most 45 characters')
      .required(i18n.t('common.fieldRequiredMessage')),
    otherwise: string().max(45, 'Id must be at most 45 characters'),
  }),
  notificationId: array().when('hideNotification', {
    is: (val) => {
      return val;
    },
    then: array().required(i18n.t('common.fieldRequiredMessage')),
    otherwise: array(),
  }),
  annotationEld: string().when('exemptFromEld', {
    is: (val) => val,
    then: string().required(i18n.t('common.fieldRequiredMessage')),
    otherwise: string(),
  }),
});

export const getSchema = ({ user }) => ({
  [SERVICE_PROVIDERS.WEBFLEET]: {
    notificationId: array().when('hideNotification', {
      is: (val) => {
        return val;
      },
      then: array().required(i18n.t('common.fieldRequiredMessage')),
      otherwise: array(),
    }),
    annotationEld: string().when('exemptFromEld', {
      is: (val) => val,
      then: string().required(i18n.t('common.fieldRequiredMessage')),
      otherwise: string(),
    }),
  },

  default: getDefaultSchema({ user }),
});
